import PropTypes from 'prop-types';
import { CardBody } from 'reactstrap';
import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import AnswerComments from 'apis/AnswerComments';

import AnswerModal from './AnswerModal';

class ReportAnswerList extends Component {
  constructor() {
    super();

    this.state = {
      comments: [],
      modal: false,
      question: '',
    };

    this.toggle = this.toggle.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { dateRange: newDateRange } = this.props;
    const prevDateRange = prevProps.dateRange;
    const isDateRangeUpdated =
      newDateRange &&
      prevDateRange &&
      (newDateRange.startDate !== prevDateRange.startDate ||
        newDateRange.endDate !== prevDateRange.endDate);

    // Clear the cached comment if the date range is updated.
    if (isDateRangeUpdated) {
      this.setState({ comments: [] });
    }
  }

  fetchComments(answer) {
    const { dateRange } = this.props;
    const { comments, modal } = this.state;

    if (comments.length > 0) {
      this.setState({ modal: !modal });

      return;
    }

    AnswerComments.getAll(
      answer.id,
      dateRange && dateRange.startDate,
      dateRange && dateRange.endDate
    )
      .then(response => {
        const cmts = response.data.comments.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        this.setState({
          modal: true,
          comments: cmts,
          question: response.data.question.question,
        });
      })
      .catch(e => {
        console.log(e);
      });
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  render() {
    const { answer, participants_count } = this.props;
    const { modal, question, comments } = this.state;

    const ratio = participants_count
      ? answer.answer_count / participants_count
      : 0;

    const reportStatusFillStyle = {
      width: `${ratio * 100}%`,
      borderBottomRightRadius: `${ratio === 1 ? '25px' : ''}`,
      borderTopRightRadius: `${ratio === 1 ? '25px' : ''}`,
    };

    return (
      <CardBody key={answer.id}>
        <div className="row">
          <div className="col-md-4">{answer.title}</div>
          <div className="col-md-3">
            <div className="report-status-bar">
              <div
                className="report-status-fill"
                style={reportStatusFillStyle}
              />
            </div>
          </div>
          <div className="col-md-3">{`${(ratio * 100).toFixed(2)} %`}</div>
          <div className="col-md-1">{answer.answer_count}</div>
          {answer.comments_count > 0 ? (
            <div className="col-md-1">
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => this.fetchComments(answer)}
              >
                <FontAwesomeIcon className="fa-2x comment-box" icon="comment" />
                <span className="comments-count">{answer.comments_count}</span>
              </div>
            </div>
          ) : null}
        </div>
        <AnswerModal
          ratio={ratio}
          answer={answer}
          toggle={this.toggle}
          isOpen={modal}
          question={question}
          comments={comments}
          participants_count={participants_count}
        />
      </CardBody>
    );
  }
}

ReportAnswerList.propTypes = {
  answer: PropTypes.shape({
    answer_count: PropTypes.number,
    id: PropTypes.string,
    comments_count: PropTypes.number,
    title: PropTypes.string,
  }),
  participants_count: PropTypes.number,
  dateRange: PropTypes.shape({
    startDate: PropTypes.any,
    endDate: PropTypes.any,
  }),
};

ReportAnswerList.defaultProps = {
  answer: {},
  participants_count: 0,
  dateRange: {},
};

export default ReportAnswerList;



// WEBPACK FOOTER //
// ./src/components/reports/ReportAnswerList.js